<template>
  <el-card class="box-card" v-loading="loading">
    <div slot="header" class="clearfix">
      <span>2、我的会议</span>
      <el-tag size="mini" type="info">单击下面标题进入会议</el-tag>
      <!-- <el-button class="tip" type="text" @click="handleMore">更多</el-button> -->
    </div>
    <div class="item" v-for="(item, index) in info" :key="item.meetNo">
      <a
        v-bind:href="
          `https://wwwxt.xjzcsq.com/TitlesMeet/CommonMeet/MavinNav?id=${item.id}&randNo=${item.randNo}`
        "
        target="_blank"
      >
        {{ index + 1 }}、 {{ item.meetTimeStr }}
        <el-tag size="mini">{{ item.stateName }}</el-tag>
        {{ item.name }}
      </a>
    </div>
  </el-card>
</template>

<script>
import { listMeet } from '@/api/tdcs/meet-mavin.js';

export default {
  data() {
    return {
      loading: false,
      info: {}
    };
  },
  methods: {
    list() {
      this.loading = true;
      listMeet().then(res => {
        this.loading = false;
        this.info = res;
      });
    }
  },
  created() {
    this.list();
  }
};
</script>

<style></style>
